import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=031a8e84&"
import script from "./Color.vue?vue&type=script&lang=js&"
export * from "./Color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports